import {
  calculateAmountDiscountCents,
  getCouponDiscountCurrencyInfo,
  getCouponPercentLabel,
  SaleCouponTypeEnum,
} from '@src/domains/coupons';
import {
  getOrderCombinedCoupon,
  getOrderRepresentativeCoupon,
  getOrderSubtotalCents,
  getOrderTotalAmountCents,
  type Order,
} from '@src/domains/orders';

export const getOrderDiscountCents = (order: Order | null | undefined): number =>
  calculateAmountDiscountCents(
    getOrderSubtotalCents(order),
    getOrderTotalAmountCents(order),
    order?.serviceFeeCurrencyInfo?.amountCents ?? 0,
  );

export const getOrderCouponDiscountCents = (order: Order | null | undefined): number => {
  const coupon = getOrderCombinedCoupon(order);

  return coupon ? getCouponDiscountCurrencyInfo(coupon).amountCents : 0;
};

export const getOrderCouponPercentLabel = (order: Order | null | undefined): string | undefined =>
  getCouponPercentLabel(getOrderRepresentativeCoupon(order), SaleCouponTypeEnum.Percentage);
